<template>
  <div @click="handleCheckElement()" class="checkbox-wrapper">
    <div class="cbx">
      <input id="cbx-12" type="checkbox" v-model="is_checked"/>
      <label for="cbx-12"></label>
      <svg width="14" height="14" viewbox="0 0 10 10" fill="none">
        <path d="M2 8.36364L6.23077 12L13 2"></path>
      </svg>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  export default Vue.extend({
    name: "Checkbox",
    props: {
      is_checked: {
        type: Boolean,
        required: true,
        default: () => false
      },
      is_disabled: {
        type: Boolean,
        required: false,
        default: () => false
      }
    },
    methods: {
      handleCheckElement: function() {
        if (this.is_disabled === true) return;
        this.$emit('input', !this.is_checked);
      }
    }
  });
</script>
<style>
  .checkbox-wrapper {
    position: relative;
  }
  .checkbox-wrapper > svg {
    position: absolute;
    top: -130%;
    left: -170%;
    width: 100px;
    pointer-events: none;
  }
  .checkbox-wrapper * {
    box-sizing: border-box;
  }
  .checkbox-wrapper input[type="checkbox"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    -webkit-tap-highlight-color: transparent;
    cursor: pointer;
    margin: 0;
  }
  .checkbox-wrapper input[type="checkbox"]:focus {
    outline: 0;
  }
  .checkbox-wrapper .cbx {
    width: 17px;
    height: 17px;
    top: calc(50vh - 8px);
    left: calc(50vw - 8px);
  }
  .checkbox-wrapper .cbx input {
    position: absolute;
    top: 0;
    left: 0;
    width: 17px;
    height: 17px;
    border: 1px solid #bfbfc0;
    border-radius: 4px;
  }
  .checkbox-wrapper .cbx label {
    width: 17px;
    height: 17px;
    background: none;
    border-radius: 4px;
    position: absolute;
    top: 0;
    left: 0;
    -webkit-filter: url("#goo-12");
    filter: url("#goo-12");
    transform: trasnlate3d(0, 0, 0);
    pointer-events: none;
  }

  .checkbox-wrapper .cbx svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    pointer-events: none;
  }
  .checkbox-wrapper .cbx svg path {
    stroke: #fff;
    stroke-width: 1.7;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-dasharray: 16.5;
    stroke-dashoffset: 16.5;
    transition: stroke-dashoffset 0.3s ease;
    transition-delay: 0.2s;
  }
  .checkbox-wrapper .cbx input:checked + label {
    animation: splash-12 0.6s ease forwards;
  }
  .checkbox-wrapper .cbx input:checked + label + svg path {
    stroke-dashoffset: 0;
  }
  @-moz-keyframes splash-12 {
    40% {
      background: rgb(114, 204, 215);
      box-shadow: 0 -18px 0 -8px rgb(114, 204, 215), 16px -8px 0 -8px rgb(114, 204, 215), 16px 8px 0 -8px rgb(114, 204, 215), 0 18px 0 -8px rgb(114, 204, 215), -16px 8px 0 -8px rgb(114, 204, 215), -16px -8px 0 -8px rgb(114, 204, 215);
    }
    100% {
      background: rgb(114, 204, 215);
      box-shadow: 0 -36px 0 -10px transparent, 32px -16px 0 -10px transparent, 32px 16px 0 -10px transparent, 0 36px 0 -10px transparent, -32px 16px 0 -10px transparent, -32px -16px 0 -10px transparent;
    }
  }
  @-webkit-keyframes splash-12 {
    40% {
      background: rgb(114, 204, 215);
      box-shadow: 0 -18px 0 -8px rgb(114, 204, 215), 16px -8px 0 -8px rgb(114, 204, 215), 16px 8px 0 -8px rgb(114, 204, 215), 0 18px 0 -8px rgb(114, 204, 215), -16px 8px 0 -8px rgb(114, 204, 215), -16px -8px 0 -8px rgb(114, 204, 215);
    }
    100% {
      background: rgb(114, 204, 215);
      box-shadow: 0 -36px 0 -10px transparent, 32px -16px 0 -10px transparent, 32px 16px 0 -10px transparent, 0 36px 0 -10px transparent, -32px 16px 0 -10px transparent, -32px -16px 0 -10px transparent;
    }
  }
  @-o-keyframes splash-12 {
    40% {
      background: rgb(114, 204, 215);
      box-shadow: 0 -18px 0 -8px rgb(114, 204, 215), 16px -8px 0 -8px rgb(114, 204, 215), 16px 8px 0 -8px rgb(114, 204, 215), 0 18px 0 -8px rgb(114, 204, 215), -16px 8px 0 -8px rgb(114, 204, 215), -16px -8px 0 -8px rgb(114, 204, 215);
    }
    100% {
      background: rgb(114, 204, 215);
      box-shadow: 0 -36px 0 -10px transparent, 32px -16px 0 -10px transparent, 32px 16px 0 -10px transparent, 0 36px 0 -10px transparent, -32px 16px 0 -10px transparent, -32px -16px 0 -10px transparent;
    }
  }
  @keyframes splash-12 {
    40% {
      background: rgb(114, 204, 215);
      box-shadow: 0 -18px 0 -8px rgb(114, 204, 215), 16px -8px 0 -8px rgb(114, 204, 215), 16px 8px 0 -8px rgb(114, 204, 215), 0 18px 0 -8px rgb(114, 204, 215), -16px 8px 0 -8px rgb(114, 204, 215), -16px -8px 0 -8px rgb(114, 204, 215);
    }
    100% {
      background: rgb(114, 204, 215);
      box-shadow: 0 -36px 0 -10px transparent, 32px -16px 0 -10px transparent, 32px 16px 0 -10px transparent, 0 36px 0 -10px transparent, -32px 16px 0 -10px transparent, -32px -16px 0 -10px transparent;
    }
  }
</style>




// WEBPACK FOOTER //
// Checkbox.vue?22c4a5cb